import { Component, Inject, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  MatDialog,
  MatTableDataSource,
  MAT_DIALOG_DATA,
  PageEvent,
} from "@angular/material";
import { Router } from "@angular/router";
import * as moment from "moment";
import { Observable } from "rxjs";
import { startWith, map, debounceTime } from "rxjs/operators";
import { UserTransaction, User, BetInfo } from "src/_models/index";
import { AppService } from "src/_services/app.service";
import { AuthenticationService } from "src/_services/authentication.service";
import { SapRoles } from "src/_constants/roleType";

export interface DialogData {
  betId: string;
}
@Component({
  selector: "app-user-account",
  templateUrl: "./user-account.component.html",
  styleUrls: ["./user-account.component.scss"],
})
export class UserAccountComponent implements OnInit {
  providersDisplayedColumns: string[] = [
    "Date",
    "Transaction",
    "Debit",
    "Credit",
    "Balance",
    "TransactionType",
    "ReferenceID",
    "Remarks",
  ];
  userAccStmt = new MatTableDataSource<UserTransaction>();

  count: number = 0;
  page = 1;
  pageSize = 25;
  orgPageSize = 25;
  users: User[] = [];
  selectedUser: { userId: string; userName: string };
  searchUserName: string = "";
  OperatorId = new FormControl([]);
  userInfo: any = JSON.parse(sessionStorage.getItem("currentUser"));
  myForm = new FormControl();
  filteredOptions: User[];
  operatorData = [];
  sapRoles = SapRoles;
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  dropdownSettings: any = {};
  length: any = 0;
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  constructor(private appService: AppService, public dialog: MatDialog, private router: Router) {}

  ngOnInit() {
    // this.getUsersList("");
    this.getOperatorData()
    this.dropdownSettings = {
      singleSelection: true,
      idField: "operator_id",
      textField: "operator_id",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }

  onSelectedOperatorId = (OperatorId) => {
    this.page = 1
    this.OperatorId.setValue([OperatorId[0].operator_id]);
    this.getUserAccountStmt();
  };

  getOperatorData() {
    try {
      this.appService.getOperatorId().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.operatorData = res.operators.sort((a, b) => {
            let fa = a.operator_id.toLowerCase(),
                fb = b.operator_id.toLowerCase();
        
            if (fa < fb) {
                return -1;
            }
            if (fa > fb) {
                return 1;
            }
            return 0;
        });
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) { }
  }

  onUserSelection(user: any) {
    this.selectedUser = user;
    this.getUserAccountStmt();
  }

  onUserSelectionClear() {
    this.selectedUser = null;
    // this.getUserAccountStmt();
    this.userAccStmt.data = null;
  }

  getUserAccountStmt(event?: PageEvent) {
    // if (event && event.pageIndex) {
    //   this.page =
    //     event.pageIndex > event.previousPageIndex
    //       ? event.pageIndex + 1
    //       : event.pageIndex - 1;
    // }

    const filters = {
      userId: this.selectedUser ? this.selectedUser.userId : "",
      operatorId: this.OperatorId.value.length !== 0 && this.OperatorId.value[0].operator_id !== "all" ? this.OperatorId.value[0].operator_id : "",
      pageSize: this.orgPageSize,
      page: this.page,
    };

    this.appService.getUserAccountStmt(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.userAccStmt.data = res.userStatement;
        this.length = res.userStatement.length;
        this.count = 100;
      }
    });
  }

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    this.getUserAccountStmt();
  }

  openDialog(bid: string) {
    this.dialog.open(UserAccDetailsModalComponent, {
      data: {
        betId: bid,
      },
    });
  }

  getBetPlaceDate(date: number) {
    return moment.unix(date / 1000).format("DD MMM YYYY hh:mm A");
  }
}

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./user-acc-details-modal.component.html",
  styleUrls: ["./user-account.component.scss"],
})
export class UserAccDetailsModalComponent implements OnInit {
  betInfo: BetInfo;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private appService: AppService
  ) {
    console.log(data);
  }

  ngOnInit() {
    this.getBetInfo();
  }

  getBetInfo() {
    try {
      this.appService.getBetDetails(this.data.betId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.betInfo = res.betDetails;
        }
      });
    } catch (err) {}
  }

  getBetPlaceDate(date: number) {
    return moment.unix(date / 1000).format("DD MMM YYYY hh:mm A");
  }
}
